import {
  getAnalytics,
  getFilterLeaderBoardByClass,
  getFilterLeaderBoardByLevel,
  getLatestGangsterDetective,
  getPopularNFTBasedOnSkill,
} from "api/api";

export const FETCH_LATEST_GANGSTERS_REQUEST =
  "FETCH_LATEST_UPDATED_GANGSTERS_REQUEST";
export const FETCH_LATEST_GANGSTERS_RECEIVED =
  "FETCH_LATEST_UPDATED_GANGSTERS_RECEIVED";
export const FETCH_LATEST_GANGSTERS_FAIL =
  "FETCH_LATEST_UPDATED_GANGSTERS_FAIL";

export const FETCH_LATEST_DETECTIVE_REQUEST =
  "FETCH_LATEST_GANGSTERS_DETECTIVE_REQUEST";
export const FETCH_LATEST_DETECTIVE_RECEIVED =
  "FETCH_LATEST_GANGSTERS_DETECTIVE_RECEIVED";
export const FETCH_LATEST_DETECTIVE_FAIL =
  "FETCH_LATEST_GANGSTERS_DETECTIVE_FAIL";

export const FETCH_LATEST_SKILL_GANGSTERS_REQUEST =
  "FETCH_LATEST_SKILL_GANGSTERS_REQUEST";
export const FETCH_LATEST_SKILL_GANGSTERS_RECEIVED =
  "FETCH_LATEST_SKILL_GANGSTERS_RECEIVED";
export const FETCH_LATEST_SKILL_GANGSTERS_FAIL =
  "FETCH_LATEST_SKILL_GANGSTERS_FAIL";

export const FETCH_ANALYTICS_DATA_REQUEST = "FETCH_ANALYTICS_DATA_REQUEST";
export const FETCH_ANALYTICS_DATA_RECEIVED = "FETCH_ANALYTICS_DATA_RECEIVED";
export const FETCH_ANALYTICS_DATA_FAIL = "FETCH_ANALYTICS_DATA_FAIL";

const fetchLatestGangstersRecieved = (data) => {
  return {
    type: FETCH_LATEST_GANGSTERS_RECEIVED,
    data: data,
  };
};

const fetchlatestGangstersFail = (error) => {
  return {
    type: FETCH_LATEST_GANGSTERS_FAIL,
    error: error,
  };
};

export const fetchLatestUpdatedGangstersData = (page) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_LATEST_GANGSTERS_REQUEST });

      const response = await getLatestGangsterDetective("Gangster", page);

      dispatch(fetchLatestGangstersRecieved(response.data.tokens));
    } catch (error) {
      dispatch(fetchlatestGangstersFail(error));
    }
  };
};

export const fetchLatestDetectiveRecieved = (data) => {
  return {
    type: FETCH_LATEST_DETECTIVE_RECEIVED,
    data: data,
  };
};

export const fetchLatestDetectiveFail = (error) => {
  return {
    type: FETCH_LATEST_DETECTIVE_FAIL,
    error: error,
  };
};

export const fetchLatestDetectiveData = (page) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_LATEST_DETECTIVE_REQUEST });

      const response = await getLatestGangsterDetective("Detective", page);

      dispatch(fetchLatestDetectiveRecieved(response.data.tokens));
    } catch (error) {
      dispatch(fetchLatestDetectiveFail(error));
    }
  };
};

export const fetchSkillGangstersRecieved = (data) => {
  return {
    type: FETCH_LATEST_SKILL_GANGSTERS_RECEIVED,
    data: data,
  };
};

export const fetchSkillGangstersFail = (error) => {
  return {
    type: FETCH_LATEST_SKILL_GANGSTERS_FAIL,
    error: error,
  };
};

export const fetchSkillGangstersData = (page) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_LATEST_SKILL_GANGSTERS_REQUEST });

      const response = await getPopularNFTBasedOnSkill(page);

      dispatch(fetchSkillGangstersRecieved(response.data.tokens));
    } catch (error) {
      dispatch(fetchSkillGangstersFail(error));
    }
  };
};

const fetchAnalyistsDataRecieved = (data) => {
  return {
    type: FETCH_ANALYTICS_DATA_RECEIVED,
    data: data,
  };
};

const fetchAnalyistsDataError = (error) => {
  return {
    type: FETCH_ANALYTICS_DATA_FAIL,
    error: error,
  };
};

export const fetchAnalyistsData = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_ANALYTICS_DATA_REQUEST });

      const response = await getAnalytics();

      dispatch(fetchAnalyistsDataRecieved(response.data));
    } catch (error) {
      dispatch(fetchAnalyistsDataError(error));
    }
  };
};

export const FETCH_POPULAR_GANGSTER_CLASS_PENDING =
  "FETCH_POPULAR_GANGSTER_CLASS_PENDING";
export const FETCH_POPULAR_GANGSTER_CLASS_FULFILLED =
  "FETCH_POPULAR_GANGSTER_CLASS_FULFILLED";
export const FETCH_POPULAR_GANGSTER_CLASS_FAIL =
  "FETCH_POPULAR_GANGSTER_CLASS_FAIL";
export const fetchPopularGangsterByClassStart = () => {
  return {
    type: FETCH_POPULAR_GANGSTER_CLASS_PENDING,
  };
};

export const fetchPopularGangsterByClassSuccess = (response) => {
  return {
    type: FETCH_POPULAR_GANGSTER_CLASS_FULFILLED,
    data: response,
  };
};

export const fetchPopularGangsterByClassFailed = (error) => {
  return {
    type: FETCH_POPULAR_GANGSTER_CLASS_FAIL,
    error: error,
  };
};

export const fetchPopularGangsterByClass = (class_type, page) => {
  return async (dispatch) => {
    dispatch(fetchPopularGangsterByClassStart());
    getFilterLeaderBoardByClass(class_type, page)
      .then((response) => {
        dispatch(fetchPopularGangsterByClassSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchPopularGangsterByClassFailed(error));
      });
  };
};

export const FETCH_POPULAR_DETECTIVE_CLASS_PENDING =
  "FETCH_POPULAR_DETECTIVE_CLASS_PENDING";
export const FETCH_POPULAR_DETECTIVE_CLASS_FULFILLED =
  "FETCH_POPULAR_DETECTIVE_CLASS_FULFILLED";
export const FETCH_POPULAR_DETECTIVE_CLASS_FAIL =
  "FETCH_POPULAR_DETECTIVE_CLASS_FAIL";
export const fetchPopularDetectiveByClassStart = () => {
  return {
    type: FETCH_POPULAR_DETECTIVE_CLASS_PENDING,
  };
};
export const fetchPopularDetectiveByClassSuccess = (response) => {
  return {
    type: FETCH_POPULAR_DETECTIVE_CLASS_FULFILLED,
    data: response,
  };
};

export const fetchPopularDetectiveByClassFailed = (error) => {
  return {
    type: FETCH_POPULAR_DETECTIVE_CLASS_FAIL,
    error: error,
  };
};

export const fetchPopularDetectiveByClass = (class_type, page) => {
  return async (dispatch) => {
    dispatch(fetchPopularDetectiveByClassStart());
    getFilterLeaderBoardByClass(class_type, page)
      .then((response) => {
        dispatch(fetchPopularDetectiveByClassSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchPopularDetectiveByClassFailed(error));
      });
  };
};

// -----------------------------------------------------------------------------------------
// Popular Level
// -----------------------------------------------------------------------------------------
// Filter level: Detective
export const FETCH_POPULAR_DETECTIVE_LEVEL_PENDING =
  "FETCH_POPULAR_DETECTIVE_LEVEL_PENDING";
export const FETCH_POPULAR_DETECTIVE_LEVEL_FULFILLED =
  "FETCH_POPULAR_DETECTIVE_LEVEL_FULFILLED";
export const FETCH_POPULAR_DETECTIVE_LEVEL_FAIL =
  "FETCH_POPULAR_DETECTIVE_LEVEL_FAIL";

export const fetchPopularDetectiveByLevelStart = () => {
  return {
    type: FETCH_POPULAR_DETECTIVE_LEVEL_PENDING,
  };
};
export const fetchPopularDetectiveByLevelSuccess = (response) => {
  return {
    type: FETCH_POPULAR_DETECTIVE_LEVEL_FULFILLED,
    data: response,
  };
};

export const fetchPopularDetectiveByLevelFailed = (error) => {
  return {
    type: FETCH_POPULAR_DETECTIVE_LEVEL_FAIL,
    error: error,
  };
};

export const fetchPopularDetectiveByLevel = (level, page) => {
  return async (dispatch) => {
    dispatch(fetchPopularDetectiveByLevelStart());
    getFilterLeaderBoardByLevel(level, page)
      .then((response) => {
        dispatch(fetchPopularDetectiveByLevelSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchPopularDetectiveByLevelFailed(error));
      });
  };
};
// Filter level: Gangster
export const FETCH_POPULAR_GANGSTER_LEVEL_PENDING =
  "FETCH_POPULAR_GANGSTER_LEVEL_PENDING";
export const FETCH_POPULAR_GANGSTER_LEVEL_FULFILLED =
  "FETCH_POPULAR_GANGSTER_LEVEL_FULFILLED";
export const FETCH_POPULAR_GANGSTER_LEVEL_FAIL =
  "FETCH_POPULAR_GANGSTER_LEVEL_FAIL";
export const fetchPopularGangsterByLevelStart = () => {
  return {
    type: FETCH_POPULAR_GANGSTER_LEVEL_PENDING,
  };
};
export const fetchPopularGangsterByLevelSuccess = (response) => {
  return {
    type: FETCH_POPULAR_GANGSTER_LEVEL_FULFILLED,
    data: response,
  };
};
export const fetchPopularGangsterByLevelFailed = (error) => {
  return {
    type: FETCH_POPULAR_GANGSTER_LEVEL_FAIL,
    error: error,
  };
};
export const fetchPopularGangsterByLevel = (level, page) => {
  return async (dispatch) => {
    dispatch(fetchPopularGangsterByLevelStart());
    getFilterLeaderBoardByLevel(level, page)
      .then((response) => {
        dispatch(fetchPopularGangsterByLevelSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchPopularGangsterByLevelFailed(error));
      });
  };
};
